import * as yup from 'yup';
export const createProceedingRequest = yup.object().shape({
    link: yup.string().required(),
    time: yup.string().required(),
    type: yup.string().required(),
    date: yup.string().required(),
    caseId: yup.string().required(),
});